import type { BuildingFireSafetySections } from "../../../types/buildings-sections/fire-safety";

export const fireSafety: BuildingFireSafetySections = {
  title: "Tuleohutus",
  description: "Hoone tuleohutuse süsteemide ja protokollide haldamine",
  noDataAvailable: "Tuleohutuse andmed puuduvad",
  creatingRecord: "Tuleohutuse kirje loomine...",
  fireSafetyClass: "Tuleohutusklass",
  selectFireSafetyClass: "Vali tuleohutusklass...",
  tp1: "TP1",
  tp2: "TP2",
  tp3: "TP3",
  occupancyLimits: "Korruste lubatud mahutavus",
  fireSafetyPlan: "Tuleohutuse plaan (link)",
  selfInspectionRequired: "Enesekontrolli nõue",
  lastInspection: "Viimane kontroll",
  systemStatus: "Süsteemide olek",
  systemPresence: "Olemasolevad süsteemid",
  systemDrawings: "Süsteemide joonised",
  scheduleInspection: "Planeeri kontroll",
  operational: "Toimib",
  partialFailure: "Osaliselt puudulik",
  nonOperational: "Ei toimi",
  addFloor: "Lisa korrus",
  addSystem: "Lisa süsteem",
  addDrawing: "Lisa joonis",
};
